module.exports = __webpack_public_path__ + "img/circle-cross.b9afda8e.svg";